import { Injectable, signal } from '@angular/core';
import { ProductEnum } from '@uc/shared/data-models';

@Injectable({
	providedIn: 'root',
})
export class CourseSearchPathService {
	private _defaultPath = '/courses/degrees';
	path = signal<string>(this._defaultPath);

	getCourseSearchSegmentsWithoutLocation(
		isHECoSSubject: boolean,
		subject: string,
		degree?: string,
	) {
		const isClearing = degree === ProductEnum.Clearing;
		const segmentsArr = isHECoSSubject
			? isClearing
				? ['/courses', degree, subject]
				: ['/courses', 'degrees', degree, subject]
			: ['/courses', 'search', degree];
		return new Set(segmentsArr.filter(Boolean));
	}
}
